import { saveImageAPI } from '@/service';
import { useMutation } from '@tanstack/react-query';
import { invalidateListImageQuery } from '@/hooks';

const saveImageBaseMutationKey = 'saveImage';
const saveImageMutationKey = [saveImageBaseMutationKey];

const saveImageFetchFunction = saveImageAPI;

export const useSaveImageMutation = () => {
  return useMutation({
    mutationKey: saveImageMutationKey,
    mutationFn: saveImageFetchFunction,
    onSuccess: async () => await invalidateListImageQuery(),
  });
};
